module.exports = __webpack_public_path__ + "static/media/info-research.ea99faf9.jpeg";